import { KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { getDeliveryStateLabel } from '../../../core/util/status-label.util';
import { BookingFlowType } from '../../../ui/enums/booking-flow-type.enum';

export const deliveryStateToLabel: Record<KnownDeliveryState, string> = {
  'in-progress': 'In Progress',
  delivered: 'Delivered',
  'delivered-offline': 'Delivered Offline',
  overdue: 'Overdue',
  collected: 'Collected',
  cancelled: 'Cancelled',
  retrieved: 'Retrieved',
  'retrieval-required': 'Retrieval Required',
  abandoned: 'Abandoned'
};

/**
 * Get delivery state label with booking flow type consideration
 */
export function getDeliveryStateLabelWithFlowType(state: KnownDeliveryState, bookingFlowType: BookingFlowType): string {
  return getDeliveryStateLabel(state, bookingFlowType);
}
